import React, { useContext, useState, useEffect } from "react";
import { AppBar, Button, Menu, MenuItem, Toolbar } from "@mui/material";
import { styled } from "@mui/system";
import { useTranslation } from "react-i18next";
import { AppConfig } from "../../context/context";
import { APP_LANGUAGES } from "../../utils/constants";
import ArrowDropDownSharpIcon from "@mui/icons-material/ArrowDropDownSharp";

const TopNav = styled("div")({
  ".topNav": {
    backgroundColor: "transparent !important",
  },
  ".menuItem": {
    display: "flex !important",
    padding: "6px 16px !important",
    justifyContent: "flex-start !important",
  },
  ".toolbar": {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "& h3": {
      color: "var(--kyocera-dark-grey)",
    },
  },
  ".languageButton": {
    width: 110,
    margin: 10,
    textTransform: "none",
    color: "var(--kyocera-dark-grey)",
  },
});

const MainTopNavComponent: React.FC = () => {
  const { i18n } = useTranslation();
  const config = useContext(AppConfig);
  const [languageMenuEl, setLanguageMenuEl] = useState<null | HTMLElement>(null);
  const [userLanguage, setUserLanguage] = useState("en");

  useEffect(() => {
    if (config?.config.language) {
      setUserLanguage(config?.config.language);
      i18n.changeLanguage(config?.config.language);
    }
  }, [config?.config?.language, i18n]);

  const handleLanguageClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setLanguageMenuEl(event.currentTarget);
  };

  const handleLanguageClose = () => {
    setLanguageMenuEl(null);
  };

  const handleLanguageChange = (code: string) => {
    setUserLanguage(code);
    i18n.changeLanguage(code);
    handleLanguageClose();
  };

  return (
    <TopNav>
      {/*
      <AppBar position="static" className="topNav">
        <Toolbar className="toolbar">
          <h3 />
          <div>
            <Button onClick={handleLanguageClick} className="languageButton">
              {APP_LANGUAGES[userLanguage]?.full || "Language"}
              <ArrowDropDownSharpIcon />
            </Button>
            <Menu
              id="language-menu"
              anchorEl={languageMenuEl}
              keepMounted
              open={Boolean(languageMenuEl)}
              onClose={handleLanguageClose}
            >
              {Object.entries(APP_LANGUAGES).map(([key, value]) => (
                <MenuItem
                  key={value.code}
                  className="menuItem"
                  onClick={() => handleLanguageChange(value.code)}
                  dense
                >
                  {value.full}
                </MenuItem>
              ))}
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
      */}
    </TopNav>
  );
};

export default MainTopNavComponent;
